import styled from 'styled-components';
import { palette } from 'styled-tools';

export const AdditionalContentWrapper = styled.main`
	background: ${palette('gray0')};
	position: relative;
`;
